import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function RelatedArticles({ slugs }: { slugs: string[] }) {
  const list = slugs
    .map((slug) => articles.find((item) => item.slug === slug))
    .filter((item): item is (typeof articles)[number] => Boolean(item))
    .slice(0, 3);

  if (list.length === 0) return null;

  return (
    <section className="border-t border-background-200 pt-10">
      <h2 className="mb-6 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        相关档案推荐
      </h2>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((item) => (
          <ArticleCard key={item.slug} article={item} />
        ))}
      </div>
    </section>
  );
}